module.exports = __webpack_public_path__ + "static/img/special-banner.2b5a2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/special-banner.jpg
// module id = wIq8
// module chunks = 7